
import styles from './index.module.scss'
import Utils from '@utils/utils'
import React, { useEffect } from 'react';
import { Image } from 'antd'
import { IMAGE_TYPE, TYPETITLEMAP, CLOTH_COLOR_TYPE } from '@utils/CONST'
import Iconfont from '@utils/Iconfont';


const ProjectDetailGroupsTitle = (props) => {

    const { item, imageType } = props;

    const mainTitle = (
        <span className={styles.mainTitle}>{
            (imageType == IMAGE_TYPE.MODEL && item.keepBkg) ?
                '换模特' : (imageType == IMAGE_TYPE.MODEL && item.keepPose) ? '换背景' :
                    (imageType == IMAGE_TYPE.CLOTH_RECOLOR && item.mode == CLOTH_COLOR_TYPE.CLOTH_RECOLOR) ? '自由换色' :
                        (imageType == IMAGE_TYPE.CLOTH_RECOLOR && item.mode == CLOTH_COLOR_TYPE.SIM_RECOLOR) ? '同款换色' :
                            TYPETITLEMAP[imageType]
        }</span>
    )

    const personTitle = item.keepPose ?
        null :
        <React.Fragment>
            <Image className={styles.thumbnail} src={Utils.getImgThumbnail(item?.person?.url)} />
            <span className={styles.title}>
                {
                    item?.person?.custom ? "自定义模特" :
                        item?.person?.title?.split("-").pop()
                }
            </span>
        </React.Fragment>

    const bkgTitle = item.keepBkg ?
        null :
        <React.Fragment>
            <Image className={styles.thumbnail} src={Utils.getImgThumbnail(item?.background?.url)} />
            <span className={styles.title}>
                {
                    item?.background?.custom ? "自定义背景" :
                        item?.background?.title?.split("-").pop()
                }
            </span>
        </React.Fragment>

    const poseTitle = <React.Fragment>
        <Image className={styles.thumbnail} src={Utils.getImgThumbnail(item?.pose?.url)} />
        <span className={styles.title}>
            {
                item?.pose?.custom ? "自定义参考图" :
                    '参考图'
            }
        </span>
    </React.Fragment>

    const shoesTitle = <React.Fragment>
        <Image className={styles.thumbnail} src={Utils.getImgThumbnail(item?.shoesRef?.url)} />
        <span className={styles.title}>
            {
                item?.shoesRef?.custom ? "自定义参考图" :
                    '预设参考图'
            }
        </span>
    </React.Fragment>

    const reColorTitle = <React.Fragment>
        <span className={styles.colorBox} style={{ backgroundColor: item.color }} ></span>
        <span className={styles.title}>{item.color}</span>
    </React.Fragment>

    const simReColorTitle = <React.Fragment>
        {
            item.clothes?.split(',').map((url) => (
                <Image style={{marginRight: 5}} className={styles.thumbnail} src={Utils.getImgThumbnail(url)} />
            ))
        }
        <span className={styles.title}>
            衣服平铺图
        </span>
    </React.Fragment>

    const commidityTitle = <React.Fragment>
        <Image className={styles.thumbnail} src={Utils.getImgThumbnail(item?.background?.url)} />
        <span className={styles.title}>
            {
                item?.background?.custom ? "自定义背景" :
                    item?.background?.title?.split("-").pop()
            }
        </span>
    </React.Fragment>
    const modelTitle = <React.Fragment>
        <Iconfont type={item?.mode == 'hq' ? "icon-hdOutlined" : "icon-stdOutlined"} className={styles.Icon} />
        <span className={styles.title}>
            {
                item?.mode == 'hq' ? "高品质模式" : item?.mode == 'std' ?
                    "标准模式" : null
            }
        </span>
    </React.Fragment>
    const poseTryonTitle = <React.Fragment>
        <Image className={styles.thumbnail} src={Utils.getImgThumbnail(item?.poseRef?.url)} />
        <span className={styles.title}>
            {
                item?.poseRef?.custom ? "自定义参考图" :
                    '预设参考图'
            }
        </span>
    </React.Fragment>
    const glassesTryonTitle = <React.Fragment>
        <Image className={styles.thumbnail} src={Utils.getImgThumbnail(item?.glassesRef?.url)} />
        <span className={styles.title}>
            {
                item?.glassesRef?.custom ? "自定义参考图" :
                    '预设参考图'
            }
        </span>
    </React.Fragment>
    const simTryonTitle = <React.Fragment>
        <Image className={styles.thumbnail} src={Utils.getImgThumbnail(item?.poseRef?.url)} />
        <span className={styles.title}>
            {
                item?.poseRef?.custom ? "自定义参考图" :
                    '预设参考图'
            }
        </span>
    </React.Fragment>

    const resolutionAlignTitle = <React.Fragment>
        <span className={styles.title}>
            {
                item?.resolutionAlign == 'bkg' ? "参考图比例" : item?.resolutionAlign == 'input' ?
                    "上传图比例" : null
            }
        </span>
    </React.Fragment>

    return (
        <div className={styles.ProjectDetailGroupsTitle}>
            {mainTitle}
            {imageType == IMAGE_TYPE.CLOTHES && poseTitle}
            {(imageType == IMAGE_TYPE.CLOTHES || imageType == IMAGE_TYPE.MODEL) && personTitle}
            {(imageType == IMAGE_TYPE.CLOTHES || imageType == IMAGE_TYPE.MODEL) && bkgTitle}
            {imageType == IMAGE_TYPE.COMMODITYRECOLOR && reColorTitle}
            {imageType == IMAGE_TYPE.CLOTH_RECOLOR && (item.mode == CLOTH_COLOR_TYPE.CLOTH_RECOLOR ? reColorTitle : simReColorTitle)}
            {imageType == IMAGE_TYPE.SHOES && shoesTitle}
            {imageType == IMAGE_TYPE.COMMODITY && commidityTitle}
            {(imageType == IMAGE_TYPE.CLOTHES || imageType == IMAGE_TYPE.SHOES) && modelTitle}
            {(imageType == IMAGE_TYPE.POSE_TRYON) && poseTryonTitle}
            {(imageType == IMAGE_TYPE.GLASSES_TRYON) && glassesTryonTitle}
            {(imageType == IMAGE_TYPE.SIM_TRYON) && simTryonTitle}
            {(imageType == IMAGE_TYPE.MODEL) && resolutionAlignTitle}
        </div>
    )
}

export default ProjectDetailGroupsTitle